import styled from "styled-components"

export const Header = styled.header`
  background: white;
  border: 1px solid #CCC;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size: 14px;
  display: flex;
  padding: 12px;
`

export const HeadIcon = styled.div`
  width: 40px;
`

export const HeadExpand = styled.div`
  flex: 1;
`

export const HeadContent = styled.div`
  margin-left: 8px;
  min-width: 120px;
`

export const HeadButton = styled.div`
  min-width: 50px;
`

export const ItemIcon = styled.div`
  min-width: 40px;
`

export const ItemExpand = styled.div`
  flex: 1;
`

export const ItemContent = styled.div`
  margin-left: 8px;
  min-width: 120px;
`

export const ItemButton = styled.div`
  min-width: 50px;
`